/**
 * AsyncStorage Wrapper
 * Helper functions for storing and retrieving data
 */

import AsyncStorage from '@react-native-async-storage/async-storage';
import { STORAGE_KEYS } from './constants';

export const storage = {
  /**
   * Store access token
   */
  setAccessToken: async (token: string): Promise<void> => {
    await AsyncStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  },

  /**
   * Get access token
   */
  getAccessToken: async (): Promise<string | null> => {
    return await AsyncStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  },

  /**
   * Store refresh token
   */
  setRefreshToken: async (token: string): Promise<void> => {
    await AsyncStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token);
  },

  /**
   * Get refresh token
   */
  getRefreshToken: async (): Promise<string | null> => {
    return await AsyncStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
  },

  /**
   * Store user data
   */
  setUserData: async (userData: any): Promise<void> => {
    await AsyncStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(userData));
  },

  /**
   * Get user data
   */
  getUserData: async (): Promise<any | null> => {
    const data = await AsyncStorage.getItem(STORAGE_KEYS.USER_DATA);
    return data ? JSON.parse(data) : null;
  },

  /**
   * Mark that the user has completed their first post-onboarding session (seen Chat).
   * On subsequent app opens, the default landing will be Dashboard instead of Chat.
   */
  setHasCompletedFirstSession: async (): Promise<void> => {
    await AsyncStorage.setItem(STORAGE_KEYS.HAS_COMPLETED_FIRST_SESSION, 'true');
  },

  /**
   * Check whether the user has already completed their first post-onboarding session.
   */
  getHasCompletedFirstSession: async (): Promise<boolean> => {
    const value = await AsyncStorage.getItem(STORAGE_KEYS.HAS_COMPLETED_FIRST_SESSION);
    return value === 'true';
  },

  /**
   * Clear all auth data
   */
  clearAuth: async (): Promise<void> => {
    await AsyncStorage.multiRemove([
      STORAGE_KEYS.ACCESS_TOKEN,
      STORAGE_KEYS.REFRESH_TOKEN,
      STORAGE_KEYS.USER_DATA,
    ]);
  },

  /**
   * Clear all data
   */
  clearAll: async (): Promise<void> => {
    await AsyncStorage.clear();
  },
};

